import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'
import colors from "vuetify/lib/util/colors";

Vue.use(Vuetify, {
  iconfont: 'md',
  theme:{
    primary: '#002b48'
  }
})
